var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{style:({
    width: _vm.header.width || null,
  })},[_c('div',{staticClass:"bt-table-cell-wrapper"},[_c('div',{staticClass:"bt-table-cell-content"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.value)+" ")]},{"item":_vm.item})],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }